import React, { useEffect } from "react";

import { makeStyles } from "@material-ui/core";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { motion } from "framer-motion";
import clsx from "clsx";

import SEO from "../components/SEO";
import Link from "../components/v2/Link";
import whatsappIcon from "../images/v4/mastercard/icons/whatsapp.svg";
import LazyImage from "../components/v4/LazyLoadImage/LazyImage";
import TruestedSection from "../components/v4/TrustedSection/TruestedSection";
import FaqSection from "../components/v4/FaqSection/FaqSection";

import card1 from "../images/v4/mastercard/images/card1.webp";
import card2 from "../images/v4/mastercard/images/card2.webp";
import card3 from "../images/v4/mastercard/images/card3.webp";
import card4 from "../images/v4/mastercard/images/card4.webp";
import card5 from "../images/v4/mastercard/images/card5.webp";
import card6 from "../images/v4/mastercard/images/card6.webp";


import bentoSectionBg1 from "../images/v4/mastercard/images/bentoSectionBg1.webp";
import bentoSectionBg1Mob from "../images/v4/mastercard/images/bentoSectionBg1Mob.webp";
import bentoSectionBg2 from "../images/v4/mastercard/images/bentoSectionBg2.webp";
import bentoSectionBg2Mob from "../images/v4/mastercard/images/bentoSectionBg2Mob.webp";
import bentoSectionBg3 from "../images/v4/mastercard/images/bentoSectionBg3.webp";
import bentoSectionBg3Mob from "../images/v4/mastercard/images/bentoSectionBg3Mob.webp";
import bentoSectionBg4 from "../images/v4/mastercard/images/bentoSectionBg4.webp";
import bentoSectionBg4Mob from "../images/v4/mastercard/images/bentoSectionBg4Mob.webp";
import bentoSectionBg5 from "../images/v4/mastercard/images/bentoSectionBg5.webp";
import bentoSectionBg5Mob from "../images/v4/mastercard/images/bentoSectionBg5Mob.webp";
import bentoSectionBg6 from "../images/v4/mastercard/images/bentoSectionBg6.webp";
import bentoSectionBg6Mob from "../images/v4/mastercard/images/bentoSectionBg6Mob.webp";

import whatsappBusinessPartner from "../images/v3/singaporeCrmHomepage/whatsappBusinessPartner.png";
import metaBusinessPartner from "../images/v3/singaporeCrmHomepage/metaBusinessPartner.png";
import trailBlazerBusinessPartner from "../images/v3/singaporeCrmHomepage/trailBlazerBusinessPartner.png";

import cardBg1 from "../images/v4/mastercard/images/cardBg1.svg";
import cardBg2 from "../images/v4/mastercard/images/cardBg2.svg";
import cardBg3 from "../images/v4/mastercard/images/cardBg3.svg";
import cardBg4 from "../images/v4/mastercard/images/cardBg4.svg";
import cardBg5 from "../images/v4/mastercard/images/cardBg5.svg";
import cardBg6 from "../images/v4/mastercard/images/cardBg6.svg";

import checkIcon from "../images/v4/mastercard/icons/checkIcon.svg";
import whatsappCrmBg from "../images/v4/mastercard/images/whatsappCrmBg.png";
import sellAndSupportBg from "../images/v4/mastercard/images/sellAndSupportBg.png";
import keyImg from "../images/v4/mastercard/images/keyImage.webp";
import bussinessSuccessbg from "../images/v4/mastercard/images/businessSuccessBg.png";
import whatsappAiCRM from "../images/v4/mastercard/icons/whatsappAiCRM.svg";
import heroSectionBg from "../images/v4/mastercard/images/heroSectionBg.webp";
import heroSectionMobImg from "../images/v4/mastercard/images/heroSectionMobImg.webp";
import heroSectionBgMob from "../images/v4/mastercard/images/heroSectionBgMob.png";
import pricingBg from "../images/v4/mastercard/images/pricingBg.png";
import whiteCheckIcon from "../images/v4/mastercard/icons/whiteCheckIcon.svg";
import aiIcon from "../images/v4/aiPage/icons/aiIcon.svg";
// import heroFeatureImg from "../images/v4/mastercard/images/heroFeatureImg.png";

import client1 from "../images/v4/mastercard/icons/client1.svg";
import client2 from "../images/v4/mastercard/icons/client2.svg";
import client3 from "../images/v4/mastercard/icons/client3.svg";
import client4 from "../images/v4/mastercard/icons/client4.svg";
import client5 from "../images/v4/mastercard/icons/client5.svg";
import client6 from "../images/v4/mastercard/icons/client6.svg";
import client7 from "../images/v4/mastercard/icons/client7.svg";
import client8 from "../images/v4/mastercard/icons/client8.svg";

import starterIcon from "../images/v4/mastercard/icons/starterIcon.svg";
import advancedIcon from "../images/v4/mastercard/icons/advancedIcon.svg";
import basicIcon from "../images/v4/mastercard/icons/basicIcon.svg";

import feature1 from "../images/v4/mastercard/icons/feature1.svg";
import feature2 from "../images/v4/mastercard/icons/feature2.svg";
import feature3 from "../images/v4/mastercard/icons/feature3.svg";
import feature4 from "../images/v4/mastercard/icons/feature4.svg";
import feature5 from "../images/v4/mastercard/icons/feature5.svg";
import feature6 from "../images/v4/mastercard/icons/feature6.svg";

import leadCaptureIcon from "../images/v4/industryPage/leadCpature.png";
import quatationIcon from "../images/v4/industryPage/quatation.png";
import contactManagemntIcon from "../images/v4/industryPage/contactManagement.png";
import pipelineIcon from "../images/v4/industryPage/pipeline.png";
import omniChannelIcon from "../images/v4/industryPage/omnichannel.png";
import emailMarketingIcon from "../images/v4/industryPage/emailmarketing.png";
import salesForecastIcon from "../images/v4/industryPage/salesForecast.png";
import opportunityMangeIcon from "../images/v4/industryPage/opportunityManagement.png";
import aiChatbotIcon from "../images/v4/industryPage/aiChatbot.png";
import whatsappCrmIcon from "../images/v4/industryPage/whatsappCrm.png";
import mobileCrmIcon from "../images/v4/industryPage/mobileCrm.png";
import utmTrackingIcon from "../images/v4/industryPage/utmTracking.png";
import realTimeDashboardIcon from "../images/v4/industryPage/realTimeDashboard.png";
import voipToolIcon from "../images/v4/industryPage/voipTool.png";
import videoConferencingIcon from "../images/v4/industryPage/videoConference.png";

const useStyles = makeStyles((theme) => ({
  heroSection: {
    backgroundImage: `url(${heroSectionBg})`,
    backgroundPosition: "bottom",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    paddingTop: "100px",
    paddingBottom: '450px',
    position: "relative",
    "& .mobileImage": {
      display: 'none'
    },
    "& .container": {
      display: "flex",
      justifyContent: "space-between",
    },

    "& .containerLeft": {
      width: "50%",
      display: "flex",
      flexDirection: "column",
      gap: "20px",
      "& .gradientPart": {
        background: "linear-gradient(90deg, #0766ED 0%, #25D366 100%)",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
      },
    },

    "& .containerRight": {
      width: "35%",
      height: "max-content",
      backgroundColor: "white",
      borderRadius: "16px",
      padding: "0",
      boxShadow: "0px 0px 24.8px 0px rgba(0, 0, 0, 0.15)",
    },

    "& .featureImg": {
      position: "absolute",
      bottom: "0",
      width: "100%"
    },
    "@media only screen and (max-width: 600px)": {
      paddingTop: '0',
      paddingBottom: '0',
      backgroundImage: `url(${heroSectionBgMob})`,
      "& .container": {
        flexDirection: 'column',
        gap: '0px'
      },
      "& .containerLeft": {
        width: '100%'
      },
      "& .containerRight": {
        width: '100%'
      },
      "& .mobileImage": {
        display: 'block'
      },
    },
    "@media only screen and (min-width: 1000px) and (max-width: 1199px)": {
      paddingBottom: '200px',
    },
    "@media only screen and (min-width: 1200px) and (max-width: 1400px)": {
      paddingBottom: '380px',
    },
    "@media only screen and (min-width: 1401px) and (max-width: 1700px)": {
      paddingBottom: '380px',
    },
    "@media only screen and (min-width: 1900px)": {
      paddingBottom: '560px',
    },
    "@media only screen and (min-width: 2500px)": {
      paddingBottom: '800px',
    }
  },
  Client: {
    position: "relative",
    zIndex: "10",
    // backgroundImage: `url(${clientbg})`,
    // backgroundRepeat: "no-repeat",
    // backgroundSize: "cover",
    // backgroundPosition: "top",
    "& .container": {
      paddingBottom: '10px'
    },
    background: "#210538",
    "@media(max-width:1024px)": {
      "& .client-logo": {
        "& img": {
          width: "auto",
          height: "25px!important",
        },
      },
    },

    "@media(max-width:600px)": {
      "& .client-logo": {
        "& img": {
          width: "auto",
          height: "20px!important",
        },
      },
    },

    "& p": {
      textAlign: "center",
      marginBottom: "64px",
      "@media(max-width:1024px)": {
        marginBottom: "32px",
      },

      "@media(max-width: 600px)": {
        marginBottom: "18px",
      },
    },
    "& .client-logo": {
      width: "auto!important",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "& img": {
        width: "auto",
        height: "35px",
      },
    },
  },

  whatsappCRM: {
    backgroundImage: `url(${whatsappCrmBg})`,
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    "& .primaryButtonOutline": {
      minWidth: 'max-content'
    },
    "& .whatsappCrmIcon": {
      background: "linear-gradient(90deg, #006238 0%, #00B845 100%)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
    },
    "& $integrationLeft": {
      width: '55%'
    },
    "& $integrationRight": {
      width: '40%'
    },
    "@media only screen and (max-width: 600px)": {
      "& $integrationLeft": {
        width: '100%'
      },
      "& $integrationRight": {
        width: '100%'
      },
      "& .whatsappCrmIcon": {
        "& img": {
          height: '50px',
          width: '50px',
        }
      },
      "& .card-content": {
        flexDirection: 'column-reverse',
        padding: "20px 15px",
        "& .cardImg": {
          width: '100%',
          height: '100%',
          marginBottom: "20px",
          marginTop: "0",
        }
      },
    }
  },

  integrationHeader: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    width: "100%",
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      gap: "30px",
    },
  },

  integrationLeft: {
    width: "50%",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  integrationRight: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    width: "40%",
    gap: "32px",

    "& .buttonContaienr": {
      "& a": {
        color: "#000",
        "&:hover": {
          color: "#fff",
        },
      },
    },
    // "& .primaryButtonOutline": {
    //   minWidth: "auto",
    //   border: "1px solid #C8D3E0",
    // },

    "& .buttons": {
      display: "flex",
      gap: "16px",
    },

    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  broadcastImg: {
    width: "100%",
    position: "relative",
    bottom: "0",
  },
  cardBackground: {
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
  },

  keyFeature: {
    backgroundImage: `url(${sellAndSupportBg})`,
    backgroundPosition: "top",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    "& .centerContainer": {
      width: "80%",
      textAlign: "center",
      margin: "0 auto",
      display: "flex",
      gap: "32px",
      flexDirection: "column",
      justifyContent: "flex-start",
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
    "& .gradientTitle": {
      background: "linear-gradient(90deg, #9332E1 0%, #008AFF 100%)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  keyFeatureContainer: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    width: "100%",
    background: "#fff",
    padding: "32px",
    borderRadius: "24px",
    marginTop: "60px",
    boxShadow: "0px 0px 15.3px 0px rgba(187, 189, 189, 0.28)",

    "& .keyImg": {
      width: "32%",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "32px",
      padding: "16px",
      flexDirection: "column",
      "& .keyImg": {
        width: "100%",
        // display: "none",
      },
    },
  },
  keyBlock: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    width: "32%",
    gap: "32px",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  keyBox: {
    width: "100%",
    gap: "16px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    "@media only screen and (max-width: 600px)": {
      gap: "12px",
    },
  },

  combineSection: {
    position: "relative",
  },
  bussinessSuccesSection: {
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundImage: `url(${bussinessSuccessbg})`,
    padding: "100px 0 200px 0",
    "& .logos-container": {
      background: "transparent",
      "&::before,&::after": {
        display: "none",
      },
      "& .logo": {
        backgroundColor: "#208EEC26",
        color: "#B6DDFF",
        "& img": {
          width: "48px",
          height: "48px",
        },
      },

      "& .scroll-container": {
        "&::before": {
          background:
            "linear-gradient(90deg,rgba(1, 28, 51, 0) 0%,rgba(1, 28, 51, 1) 100%) !important",
        },
        "&::after": {
          background:
            "linear-gradient(90deg,rgba(1, 28, 51, 1) 0%,rgba(1, 28, 51, 0) 100%) !important",
        },
      },

      "@media only screen and (max-width: 768px)": {
        paddingBottom: "0px!important",
      },
    },
    "@media only screen and (max-width: 1024px)": {
      paddingTop: "80px",
    },
    "@media only screen and (max-width: 768px)": {
      paddingTop: "60px",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "60px 0 180px",
    },
    "@media only screen and (max-width: 480px)": {
      padding: "40px 0 180px",
    },
  },
  bussinessSuccessContainer: {
    display: "flex",
    alignItems: "center",
    maxWidth: "1200px",
    margin: "0 auto",
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
    },
  },
  integrationHeaderItem: {
    width: "100%",
    marginBottom: "90px",
    color: "#fff",
    "& h2": {
      textAlign: "left",
      paddingRight: "80px",
    },
    "@media only screen and (max-width: 1024px)": {
      "& h2": {
        paddingRight: "40px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      marginBottom: "15px",
      "& h2": {
        textAlign: "center",
        paddingRight: "0",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "& h2": {
        textAlign: "center",
      },
    },
  },
  integrationContent: {
    width: "100%",
    textAlign: "center",
    color: "#fff",
    "& h2": {
      marginBottom: "16px !important",
      marginTop: "0 !important",
    },
    "& p": {
      marginBottom: "16px",
      textAlign: "left",
      paddingRight: "80px",
    },
    "@media only screen and (max-width: 1024px)": {
      "& p": {
        paddingRight: "40px",
        fontSize: "18px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      "& p": {
        paddingRight: "0",
        textAlign: "center",
        fontSize: "16px",
        marginBottom: "0",
      },
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      marginBottom: "20px",
      "& p": {
        fontSize: "14px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      "& p": {
        fontSize: "13px",
      },
    },
  },
  absoulteCard: {
    position: "absolute",
    margin: "0 auto",
    width: "100%",
    top: "100%",
    transform: "translate(-50% ,-50%)",
    left: "50%",
    right: "0",
    "& .container": {
      paddingTop: "0",
    },
    "@media only screen and (max-width: 768px)": {

    },
  },
  wpFaq: {
    // paddingTop: "120px",
    "@media only screen and (max-width: 600px)": {
      "& section": {
        padding: "0px 0 0 !important",
      },
    },
  },
  commonPageFooterSection: {
    background:
      "transparent linear-gradient(90deg, #011D32 0%, #00182B 100%) 0% 0% no-repeat padding-box",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
    },
    "@media only screen and (max-width: 600px)": {
      "& .centerContainer": {
        width: "100%",
      },
    },
  },
  bentoSection: {
    background: 'linear-gradient(180deg, #210538 0%, #00325C 100%)',
    "& .aiHeading": {
      background: "linear-gradient(94deg, #9CC4FF 6.05%, #5DFCFF 98.18%)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
    },
    "& .aiIcon": {
      "& img": {
        height: '55px',
        width: '55px',
        top: '8px',
        marginLeft: '5px',
        position: 'relative',
        "@media only screen and (max-width: 600px)": {
          height: '32px',
          width: '32px',
          top: '5px',
          marginLeft: '0px',
          marginRight: '5px',
        }
      }

    }

  },
  bentoContainer: {
    display: 'flex',
    flexDirection: "column",
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    gap: '20px',
    width: '100%',
    marginTop: '40px',
  },
  bentoRow1: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'stretch',
    gap: '20px',
    width: '100%',
    "@media only screen and (max-width: 600px)": {
      flexDirection: 'column'
    }
  },
  bentoRow2: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'stretch',
    gap: '20px',
    width: '100%',
    "@media only screen and (max-width: 600px)": {
      flexDirection: 'column'
    }
  },
  bentoRow3: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'stretch',
    gap: '20px',
    width: '100%',
    "@media only screen and (max-width: 600px)": {
      flexDirection: 'column'
    }
  },
  bentoCard: {
    overflow: 'hidden',
    position: 'relative',
    zIndex: "1",
    display: 'flex',
    flexDirection: "column",
    justifyContent: 'flex-end',
    alignItems: 'flex-start',
    gap: '20px',
    borderRadius: '16px',
    backgroundSize: 'cover',
    backgroundPosition: 'top left',
    backgroundRepeat: 'no-repeat',
    minHeight: '360px',
    "& .content": {
      padding: '20px',
      display: 'flex',
      width: '100%',
      flexDirection: "column",
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      gap: '12px',
    },
    "@media only screen and (max-width: 600px)": {
      minHeight: '400px'
    },
    "&.card1": {
      width: '32%',
      backgroundImage: `url(${bentoSectionBg1})`,
      "@media only screen and (max-width: 600px)": {
        backgroundImage: `url(${bentoSectionBg1Mob})`,
        width: '100%'
      }
    },
    "&.card2": {
      width: '32%',
      backgroundImage: `url(${bentoSectionBg2})`,
      "@media only screen and (max-width: 600px)": {
        backgroundImage: `url(${bentoSectionBg2Mob})`,
        width: '100%'
      }
    },
    "&.card3": {
      width: '32%',
      backgroundImage: `url(${bentoSectionBg3})`,
      "@media only screen and (max-width: 600px)": {
        backgroundImage: `url(${bentoSectionBg3Mob})`,
        width: '100%'
      }

    },
    "&.card4": {
      width: '100%',
      backgroundImage: `url(${bentoSectionBg4})`,
      "@media only screen and (max-width: 600px)": {
        backgroundImage: `url(${bentoSectionBg4Mob})`,
        width: '100%'
      },
      "& .content": {
        width: '50%',
        "@media only screen and (max-width: 600px)": {
          width: '100%'
        },
      }
    },
    "&.card5": {
      width: '49%',
      backgroundImage: `url(${bentoSectionBg5})`,
      "@media only screen and (max-width: 600px)": {
        backgroundImage: `url(${bentoSectionBg5Mob})`,
        width: '100%'
      }
    },
    "&.card6": {
      width: '49%',
      backgroundImage: `url(${bentoSectionBg6})`,
      "@media only screen and (max-width: 600px)": {
        backgroundImage: `url(${bentoSectionBg6Mob})`,
        width: '100%'
      }
    },
    "&.blueCard": {
      // background: "#053333",
      // "&:hover": {
      //   boxShadow: "0 0 16px 2px #009A99;",
      // },
      "& .offPrice": {
        background: '#009A99'
      },
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #1ADAD9 30%, #00aa7c 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.regularCard": {
      // background: "#0A2F4F",
      // "&:hover": {
      //   boxShadow: "0 0 16px 2px #208EEC;",
      // },
      "& .offPrice": {
        background: '#208EEC'
      },
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #3ac4ff 30%, #1f79d3 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.purpleCard": {
      // background: "#31114B",
      // "&:hover": {
      //   boxShadow: "0 0 16px 2px #9E5AD5;",
      // },
      "& .offPrice": {
        background: '#9E5AD5'
      },
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "400px",
          height: "400px",
          zIndex: "-1",
          background: "radial-gradient(circle, #FF8958 0%, #B458FF 100%)",
          borderRadius: "50%",
          filter: "blur(200px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
  },
  pricingSection: {
    paddingTop: '220px',
    paddingBottom: '40px',
    backgroundImage: `url(${pricingBg})`,
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    "& .centerContainer": {
      width: "70%",
      textAlign: "center",
      margin: "0 auto",
      display: "flex",
      gap: "32px",
      flexDirection: "column",
      justifyContent: "flex-start",
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
    "@media only screen and (max-width: 600px)": {
      paddingTop: '140px',
      paddingBottom: '0',
    }
  },
  pricingContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    gap: '60px',
    marginTop: '100px',
    "@media only screen and (max-width: 600px)": {
      flexDirection: 'column',
      gap: '20px',
      marginTop: '40px'
    }
  },
  pricingBox: {
    display: 'flex',
    zIndex: '1',
    overflow: 'hidden',
    position: 'relative',
    width: '26%',
    flexDirection: "column",
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: '16px',
    padding: '24px 8px 8px',
    borderRadius: '16px',
    transition: "0.3s ease",
    "& .transparentButton": {
      "&:hover": {
        background: "#FF6A2B",
        borderColor: 'transparent'
      }
    },
    // "&:hover": {
    //   scale: "1.05"
    // },
    "@media only screen and (max-width: 600px)": {
      width: '100%',
      scale: '1',
      "& .transparentButton": {
        background: "#FF6A2B",
        borderColor: 'transparent'
      },
      padding: '32px 16px 16px',
      "&:hover": {
        scale: '1'
      }
    },
    "& .tag": {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      gap: '5px',
      padding: "8px 12px",
      borderRadius: '100px',
      background: 'rgba(255, 255, 255, 0.10)'
    },
    "& .cutPrice": {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '5px'
    },
    "& .slashPrice": {
      opacity: '0.6',
      color: '#fff',
      textDecoration: 'line-through'
    },
    "& .offPrice": {
      padding: '1px 8px',
      borderRadius: '100px'
    },
    "& .actualPrice": {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    },
    "&.blueCard1": {
      background: "#053333",
      "& $pricingPointers": {
        "@media only screen and (max-width: 600px)": {
          background: 'rgba(0, 154, 153, 0.10)',
        }
      },
      "&:hover": {
        boxShadow: "0 0 16px 2px #009A99;",
      },
      "& .offPrice": {
        background: '#009A99'
      },
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #1ADAD9 30%, #00aa7c 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.regularCard1": {
      background: "#0A2F4F",
      "& $pricingPointers": {
        "@media only screen and (max-width: 600px)": {
          background: 'rgba(32, 142, 236, 0.10)',
        }
      },
      "&:hover": {
        boxShadow: "0 0 16px 2px #208EEC;",
      },
      "& .offPrice": {
        background: '#208EEC'
      },
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #3ac4ff 30%, #1f79d3 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.purpleCard1": {
      scale: "1.2",
      "@media only screen and (max-width: 600px)": {
        scale: "1",
      },
      background: "#31114B",
      "& $pricingPointers": {
        "@media only screen and (max-width: 600px)": {
          background: 'rgba(158, 90, 213, 0.10)',
        }
      },
      "&:hover": {
        boxShadow: "0 0 16px 2px #9E5AD5;",
      },
      "& .offPrice": {
        background: '#9E5AD5'
      },
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "400px",
          height: "400px",
          zIndex: "-1",
          background: "radial-gradient(circle, #FF8958 0%, #B458FF 100%)",
          borderRadius: "50%",
          filter: "blur(200px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },

  },
  pricingPointers: {
    display: 'flex',
    width: '100%',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    gap: '12px',
    flexDirection: 'column',
    padding: '16px 8px',
    borderRadius: '12px',
    "@media only screen and (max-width: 600px)": {

      padding: '26px 8px',
    }
  },
  pricingPointer: {
    gap: '5px',
    display: 'flex',
    width: '100%',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  cutActualContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  adaptSlider: {
    "@media only screen and (max-width: 600px)": {
      padding: "15px 15px 40px",
    },
    "@media only screen and (min-width: 1400px)": {
      padding: "15px 8rem 60px",
    },
    "@media only screen and (min-width: 1900px)": {
      padding: "15px 23rem 60px",
    },
  },
  aiPoweredContainer: {
    background: "#210538",
  },
  aiPoweredClientContainer: {
    textAlign: "center",
  },
  partnerSlide: {
    width: "144px !important",
    // filter: "brightness(0.1)",
    "& img": {
      width: "144px",
    },
    "@media only screen and (max-width: 600px)": {
      width: "max-content !important",
      "& img": {
        width: "100px",
      },
      // marginRight: "20px !important",
    },
  },
  partnerSlider: {
    padding: "10px 0  65px !important",
    "@media only screen and (max-width: 600px)": {
      paddingBottom: "40px !important",
    },
  },
  rewards: {
    display: "flex",
    alignItems: "stretch",
    justifyContent: "flex-start",
    gap: "10px",
    boxShadow: "0px 0px 6px #00000029",
    padding: "15px 20px",
    borderRadius: "100px",
    width: "80%",
    marginTop: "10px",
    background: "#fff",
    "& .border": {
      borderRight: "1px solid #DBDBDB",
      width: "0",
    },
    "& img": {
      minWidth: "30%",
      "@media only screen and (max-width: 600px)": {
        minWidth: "26%",
      },
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "10px",
      justifyContent: "space-between",
      padding: "10px",
    },
  },
}));

const allIcons = [
  {
    img: leadCaptureIcon,
    title: "Auto lead capture",
  },
  {
    img: contactManagemntIcon,
    title: "Contact management",
  },
  {
    img: pipelineIcon,
    title: "Pipeline management",
  },
  {
    img: omniChannelIcon,
    title: "Omnichannel CRM",
  },
  {
    img: emailMarketingIcon,
    title: "Email marketing",
  },
  {
    img: quatationIcon,
    title: "Quotation generation",
  },
  {
    img: salesForecastIcon,
    title: "Sales forecasting",
  },
  {
    img: opportunityMangeIcon,
    title: "Opportunity management",
  },
  {
    img: aiChatbotIcon,
    title: "AI chatbot",
  },
  {
    img: whatsappCrmIcon,
    title: "WhatsApp CRM",
  },
  {
    img: mobileCrmIcon,
    title: "Mobile CRM",
  },
  {
    img: utmTrackingIcon,
    title: "UTM tracking",
  },
  {
    img: realTimeDashboardIcon,
    title: "Real-time dashboard",
  },
  {
    img: voipToolIcon,
    title: "VOIP tool integration",
  },
  {
    img: videoConferencingIcon,
    title: "Video conferencing",
  },
];

const MasterCard = () => {
  const classes = useStyles();
  function scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }
  useEffect(() => {
    // Select all cards that should have the effect
    const cardsToAnimate = [
      ...document.querySelectorAll(`.${classes.pricingBox}.blueCard1`), // Add regularCards
      ...document.querySelectorAll(`.${classes.pricingBox}.purpleCard1`), // Add regularCards
      ...document.querySelectorAll(`.${classes.pricingBox}.regularCard1`),
      ...document.querySelectorAll(`.${classes.bentoCard}.blueCard`), // Add regularCards
      ...document.querySelectorAll(`.${classes.bentoCard}.purpleCard`), // Add regularCards
      ...document.querySelectorAll(`.${classes.bentoCard}.regularCard`),
    ];

    cardsToAnimate.forEach((card) => {
      if (!card) return;

      card.classList.add("glass-effect");

      // Set initial top-right position for the glass effect
      const setInitialPosition = () => {
        const rect = card.getBoundingClientRect();
        const topRightX = rect.width - 150; // Adjust this value to position from right edge
        const topRightY = 0; // Top position

        card.style.setProperty("--before-left", `${topRightX}px`);
        card.style.setProperty("--before-top", `${topRightY}px`);
        card.style.setProperty("--before-opacity", "0.8");
      };

      // Call it initially
      setInitialPosition();

      let lastX = null;
      let lastY = null;

      const handleMouseMove = (e) => {
        const rect = card.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        lastX = x;
        lastY = y;

        card.style.setProperty("--before-left", `${x - 75}px`);
        card.style.setProperty("--before-top", `${y - 75}px`);
      };

      const handleMouseEnter = () => {
        if (lastX !== null && lastY !== null) {
          card.style.setProperty("--before-left", `${lastX - 75}px`);
          card.style.setProperty("--before-top", `${lastY - 75}px`);
        }
        card.style.setProperty("--before-opacity", "0.8");
      };

      const handleMouseLeave = () => {
        card.style.setProperty("--before-opacity", "0.8");
      };

      // Store handlers on the card element for cleanup
      card.handlers = {
        mousemove: handleMouseMove,
        mouseenter: handleMouseEnter,
        mouseleave: handleMouseLeave,
        resize: setInitialPosition,
      };

      // Add event listeners
      card.addEventListener("mousemove", handleMouseMove);
      card.addEventListener("mouseenter", handleMouseEnter);
      card.addEventListener("mouseleave", handleMouseLeave);
      window.addEventListener("resize", setInitialPosition);
    });

    // Cleanup
    return () => {
      cardsToAnimate.forEach((card) => {
        if (!card) return;

        const handlers = card.handlers;
        if (handlers) {
          card.removeEventListener("mousemove", handlers.mousemove);
          card.removeEventListener("mouseenter", handlers.mouseenter);
          card.removeEventListener("mouseleave", handlers.mouseleave);
          window.removeEventListener("resize", handlers.resize);
        }
      });
    };
  }, [classes]);

  useEffect(() => {
    const cards = document.querySelectorAll(".card");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const card = entry.target;
          const currentIndex = Array.from(cards).indexOf(card);

          if (entry.isIntersecting) {
            // Remove all previous classes first
            cards.forEach((c) => {
              c.classList.remove(
                "is-previous-1",
                "is-previous-2",
                "is-previous-3",
                "is-previous-4",
                "is-previous-5",
                "is-previous-6",
              );
            });

            // Add appropriate classes based on distance from current card
            cards.forEach((c, index) => {
              if (index < currentIndex) {
                const difference = currentIndex - index;
                if (difference <= 6) {
                  // Only apply effects to 4 cards back
                  c.classList.add(`is-previous-${difference}`);
                }
              }
            });
          }
        });
      },
      {
        root: null,
        threshold: 0.5,
        rootMargin: "0px",
      }
    );

    cards.forEach((card) => observer.observe(card));

    return () => observer.disconnect();
  }, []);

  const clientList = [
    {
      img: client1,
      alt: "Crowe",
    },
    {
      img: client2,
      alt: "Caffeine Solutions",
    },
    {
      img: client3,
    },
    // {
    //   img: client4,
    // },
    {
      img: client5,
      alt: "Tech Data",
    },
    // {
    //   img: client6,
    // },
    {
      img: client7,
      alt: "Urban Hood",
    },
    {
      img: client8,
      alt: "Bankaool",
    },
    {
      img: client1,
      alt: "Crowe",
    },
    {
      img: client2,
      alt: "Caffeine Solutions",
    },
    {
      img: client3,
    },
    // {
    //   img: client4,
    // },
    {
      img: client5,
      alt: "Tech Data",
    },
    // {
    //   img: client6,
    // },
    {
      img: client7,
      alt: "Urban Hood",
    },
    {
      img: client8,
      alt: "Bankaool",
    },
  ];

  const capabilities = [
    {
      heading: "WhatsApp Flows",
      desc: "Boost performance with personalised journeys with WhatsApp flows. Create end-to-end journeys and close deals and tickets quickly.",
      points: [
        "Auto-capture leads with ease",
        "Streamline customer feedback collection",
        "Set up appointment booking flows"
      ],
      image: card3,
      background: cardBg1,
      alt: "ai whatsapp crm for sales and support"
    },
    {
      heading: "WhatsApp Broadcast",
      desc: "Leverage the power of WhatsApp within the CRM solution. Send bulk messages and reach out to thousands of customers at one go.",
      points: [
        "Run marketing campaigns, blast promotions, and share updates",
        "Schedule broadcast to maximise the reach",
        "Get detailed insights into the broadcast with the broadcast report"
      ],
      image: card1,
      background: cardBg2,
      alt: "mastercard member pricing for ai whatsapp crm"
    },
    {
      heading: "WhatsApp Catalog",
      desc: "Create a digital showcase of your products and services on WhatsApp. Display images, descriptions, prices, and more.",
      points: [
        "Instantly share product catalogs on WhatsApp",
        "Share single-product or multi-product catalogs with ease",
        "Empower customers to place orders on WhatsApp"
      ],
      image: card2,
      background: cardBg3,
      alt: "ai powered whatsapp crm dashboard for sales and support"
    },
    {
      heading: "Click-to-WhatsApp Ads",
      desc: "Capture and track leads from Facebook and Instagram through click-to-WhatsApp ads. Respond instantly and guide prospects toward conversion.",
      points: [
        "Auto-capture leads from WhatsApp ads to CRM directly",
        "Answer queries instantly to reduce drop-offs",
        "Set up intelligent auto-replies and convert ad clicks into qualified leads"
      ],
      image: card4,
      background: cardBg4,
      alt: "whatsapp crm automation workflows with ai"
    },
    // {
    //   heading: "WhatsApp Groups",
    //   desc: "Connect with customers or coworkers with WhatsApp groups. Manage WhatsApp groups from within your CRM system.",
    //   points: [
    //     "Manage multiple WhatsApp groups within CRM",
    //     "Share updates, announcements, and offers",
    //     "Collaborate and resolve issues quickly with WhatsApp groups"
    //   ],
    //   image: card5,
    //   background: cardBg5,
    //   alt: "whatsapp broadcast campaigns inside crm"
    // },
    {
      heading: "WhatsApp Templates",
      desc: "Initiate conversations, respond quickly, and automate conversations with pre-approved, ready-to-use WhatsApp templates.",
      points: [
        "Respond to customer queries and FAQs quickly with message templates",
        "Send greetings, alerts, reminders, and confirmations",
        "Keep the conversation interesting with media-rich and interactive CTAs"
      ],
      image: card6,
      background: cardBg6,
      alt: "pepper cloud ai whatsapp crm platform"
    },
  ];

  const featureList1 = [
    {
      title: "Customisable Pipelines",
      desc: "Customise pipelines, stages, and fields to match your unique business needs.",
      icon: feature1,
    },
    {
      title: "Sales Forecasting",
      desc: "Predict your sales revenue accurately using real-time, data-driven insights.",
      icon: feature2,
    },
    {
      title: "Track Performance",
      desc: "Keep a track of your sales, leads, and team productivity with interactive dashboards.",
      icon: feature3,
    },
  ];

  const featureList2 = [
    {
      title: "Smart Ticket Assignment",
      desc: "Auto-create and distribute them among agents with round-robin assignment.",
      icon: feature4,
    },
    {
      title: "SLA Protection",
      desc: "Auto-escalate tickets that breach predefined SLAs. Ensure ticket resolution without delays.",
      icon: feature5,
    },
    {
      title: "Sentiment Intelligence",
      desc: "Analyse customer sentiments with ease. Automate responses and prioritise urgent enquiries.",
      icon: feature6,
    },
  ];

  function distributeIcons(icons) {
    // Sort icons alphabetically to ensure consistent distribution
    const sortedIcons = [...icons].sort((a, b) =>
      a.title.localeCompare(b.title),
    );

    const logotrack1 = [];
    const logotrack2 = [];
    const logotrack3 = [];

    sortedIcons.forEach((icon, index) => {
      // Distribute icons based on their index
      switch (index % 3) {
        case 0:
          logotrack1.push(icon);
          break;
        case 1:
          logotrack2.push(icon);
          break;
        case 2:
          logotrack3.push(icon);
          break;
      }
    });

    return {
      logotrack1,
      logotrack2,
      logotrack3,
    };
  }

  // Get the distributed icons
  const { logotrack1, logotrack2, logotrack3 } = distributeIcons(allIcons);

  useEffect(() => {
    // Infinite scroll functionality

    class InfiniteScroll {
      constructor(row, speed) {
        this.row = row;
        this.track = row.querySelector(".logos-track");
        this.speed = speed;
        this.position = 0;
        this.direction = row.dataset.direction || "left";
        this.init();
      }

      init() {
        // Clone the track content
        const content = this.track.innerHTML;
        this.track.innerHTML = content + content + content;

        // Calculate total width
        const logos = this.track.querySelectorAll(".logo");
        let totalWidth = 0;
        logos.forEach((logo) => {
          totalWidth +=
            logo.offsetWidth +
            parseInt(getComputedStyle(logo).marginLeft) +
            parseInt(getComputedStyle(logo).marginRight);
        });

        // Set row height
        this.row.style.height = logos[0].offsetHeight + 10 + "px";

        // Set initial position for right-to-left movement
        if (this.direction === "left") {
          this.position = 0;
        } else {
          this.position = -this.track.offsetWidth / 3;
        }

        // Start animation
        this.animate();
      }

      animate() {
        const animate = () => {
          // Update position based on direction
          if (this.direction === "left") {
            this.position -= this.speed;
            // Reset position when one-third of content has scrolled
            const oneThirdWidth = -this.track.offsetWidth / 3;
            if (this.position <= oneThirdWidth) {
              this.position = 0;
            }
          } else {
            this.position += this.speed;
            // Reset position when one-third of content has scrolled
            if (this.position >= 0) {
              this.position = -this.track.offsetWidth / 3;
            }
          }

          this.track.style.transform = `translateX(${this.position}px)`;
          requestAnimationFrame(animate);
        };

        requestAnimationFrame(animate);
      }
    }

    // Initialize all rows with different speeds and directions
    document.querySelectorAll(".logos-row").forEach((row) => {
      const speed = parseFloat(row.dataset.speed) || 1;
      new InfiniteScroll(row, speed);
    });
  }, []);

  const faqs = [
    {
      question: "How does the AI WhatsApp CRM help my sales team daily?",
      answer: (
        <>
          Our AI CRM automates lead scoring and follow-ups, summarises meetings,
          and predicts next-best actions, allowing your team to focus on closing
          deals instead of manual data entry.
        </>
      ),
    },
    {
      question: "How does AI WhatsApp CRM help my support team?",
      answer: (
        <>
          AI CRM automates ticket creation, assignment, responses, and
          follow-ups, helping support teams resolve issues faster with less
          manual effort.
        </>
      ),
    },
    {
      question: "Can I use my landline number for WhatsApp?",
      answer: (
        <>
          Yes, the landline number can be used with the WhatsApp API, which
          integrates with the CRM solution.
        </>
      ),
    },
    {
      question: "How long does it take to set up WhatsApp for my business?",
      answer: (
        <>
          If you have all the prerequisites ready, you can start using WhatsApp
          through the CRM system within a few hours.
        </>
      ),
    },
    {
      question: "Can I use my WhatsApp number with Pepper Cloud?",
      answer: (
        <>
          Yes, Pepper Cloud AI WhatsApp CRM integrates with WhatsApp Web,
          enabling you to use your WhatsApp number within the CRM.
        </>
      ),
    },
    {
      question: "Is AI CRM suitable for growing businesses?",
      answer: (
        <>
          Yes. AI CRM scales effortlessly as your business grows. It can easily
          handle increasing data, conversations, and users without compromising
          performance or accuracy.
        </>
      ),
    },
    {
      question: "How does AI CRM reduce business operational costs?",
      answer: (
        <>
          AI CRM minimises manual work and improves team efficiency, helping
          businesses reduce support and sales overheads.
        </>
      ),
    },
    {
      question: "How can AI CRM automate business growth?",
      answer: (
        <>
          AI CRM can auto-capture leads, respond during off-business hours using
          AI chatbot, analyse customer sentiments, score and follow-up leads
          with AI agents, generate call and conversation insights with the power
          of AI and do more.
        </>
      ),
    },
  ];

  return (
    <main>
      <SEO
        noindex
        description={
          "Check out Pepper Cloud's AI WhatsApp CRM that automates sales and support. Turn WhatsApp conversations into revenue using AI-powered CRM. Automate sales, support, and workflows with special Mastercard member pricing."
        }
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Pepper Cloud",
            legalName: "Pepper Cloud PTE LTD",
            url: "https://peppercloud.com/ai-whatsapp-crm-with-exclusive-mastercard-offer",
            logo: "https://peppercloud.com/icons/logo.png",
            foundingDate: "2017",
            address: [
              {
                "@type": "PostalAddress",
                streetAddress: "#04-01/02",
                addressLocality: "Blk 79 Ayer Rajah Crescent",
                addressRegion: "SG",
                postalCode: "139955",
                addressCountry: "Singapore",
              },
              {
                "@type": "PostalAddress",
                streetAddress:
                  "2nd Floor, Salarpuria Tower 1, 7th Block Koramangala",
                addressLocality: "Bengaluru",
                addressRegion: "KA",
                postalCode: "560095",
                addressCountry: "India",
              },
            ],
            contactPoint: {
              "@type": "ContactPoint",
              contactType: "customer support",
              telephone: "+6566562616",
              email: ["sales@peppercloud.com", "support@peppercloud.com"],
            },
            sameAs: [
              "https://twitter.com/peppercloudpte",
              "https://www.linkedin.com/company/peppercloud/",
              "https://www.facebook.com/PepperCloudPteLtd",
              "https://www.instagram.com/pepper.cloud/",
            ],
          },
          {
            "@context": "https://schema.org/",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "What is the role of CRM in retail?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Retail CRM plays a crucial role in managing customer interactions, tracking sales, and enhancing service across both online and offline channels.",
                },
              },
              {
                "@type": "Question",
                name: "Why is a specialized CRM necessary for e-commerce?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "A specialized e-commerce CRM addresses challenges such as cart abandonment, personalized recommendations, and multichannel support, ultimately enhancing customer experience and driving sales.",
                },
              },
              {
                "@type": "Question",
                name: "Is investing in a CRM worthwhile for small businesses?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Pepper Cloud CRM is beneficial for small e-commerce businesses as it improves customer service, streamlines operations, and enables data-driven decision-making, leading to growth and increased profitability.",
                },
              },
              {
                "@type": "Question",
                name: "Can Pepper Cloud assist with cart abandonment?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Pepper Cloud's e-commerce CRM automates cart abandonment recovery through targeted reminders and incentives, resulting in increased conversions.",
                },
              },
              {
                "@type": "Question",
                name: "How does Pepper Cloud facilitate multichannel sales?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Pepper Cloud's e-commerce CRM offers omnichannel capabilities, managing sales and customer interactions across websites, marketplaces, and social media platforms for a unified customer view.",
                },
              },
            ],
          },
        ]}
        keywords="AI WhatsApp CRM, AI WhatsApp CRM software, WhatsApp CRM with AI, Secondary Keywords, WhatsApp CRM for sales and support, WhatsApp CRM automation, AI CRM for sales teams, AI CRM for customer support, WhatsApp chatbot CRM, WhatsApp API CRM"
        ogData={{
          "og:image": [
            "/meta/og/1X1/home.png",
            "/meta/og/1024X512/home.png",
            "/meta/og/1200X630/home.png",
          ],
        }}
        pathname={"https://peppercloud.com/user-based-tools/"}
        title={
          "AI WhatsApp CRM for Sales & Support | Exclusive Mastercard Offer"
        }
      />

      <section className={classes.heroSection}>
        <div className="container">
          <div className="containerLeft">
            <h1 className="font-wix-semibold font-64 color-black">
              <span className="gradientPart">AI WhatsApp CRM </span>
              for Sales and Support
            </h1>
            <p
              className="font-wix-regular font-18"
              style={{ color: "#020D18" }}
            >
              Turn every conversation into revenue with AI-powered WhatsApp CRM.
              Capture leads, automate follow-ups, and transform every
              conversation into a won opportunity effortlessly.
            </p>
            <div className={classes.rewards}>
              <img
                src={whatsappBusinessPartner}
                alt="WhatsApp Business Partner"
              />
              <div className="border" />
              <img src={metaBusinessPartner} alt="Meta Business Partner" />
              <div className="border" />
              <img
                src={trailBlazerBusinessPartner}
                alt="AI WhatsApp CRM for Sales & Customer Support"
              />
            </div>
            <img alt="Offer for business mastercard holders" className={'mobileImage'} src={heroSectionMobImg} width={'100%'} height={"100%"} />
          </div>

          <div className="containerRight">
            <iframe
              src="https://app.peppercloud.com/form/3955c66a-e01c-4973-835e-6ca6b525f32b/embed"
              width="100%"
              height="600"
              frameborder="0"
            ></iframe>
          </div>

          {/* <img src={heroFeatureImg} alt="hero section" className="featureImg" /> */}
        </div>
      </section>
      <section className={classes.aiPoweredContainer}>
        <div className="container">
          <div className={classes.aiPoweredClientContainer}>
            <motion.h2
              className="font-wix-medium font-24 font-white"
              initial={{ opacity: 1, y: 20 }}
              transition={{ duration: 0.3 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              Trusted by global brands across industries
            </motion.h2>
          </div>
        </div>
        <Swiper
          allowTouchMove={false}
          autoplay={{
            delay: 100,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
          }}
          className={classes.partnerSlider}
          loop={true}
          modules={[Autoplay]}
          slidesPerView="auto"
          spaceBetween={60}
          speed={2000}
        >
          {clientList.map((partner) => (
            <SwiperSlide className={classes.partnerSlide}>
              <img src={partner.img} alt={partner.alt} />
            </SwiperSlide>
          ))}
        </Swiper>
      </section>
      <section className={classes.bentoSection}>
        <div className="container">
          <div className={classes.integrationHeader}>
            <div className={classes.integrationLeft}>
              <motion.h2
                initial={{ opacity: 1, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                className="font-wix-semibold font-56 font-white"
              >
                Automate workflows with
                <span className="aiHeading font-wix-semibold font-56 color-black">
                  <LazyImage className="aiIcon" source={aiIcon} alt={"AssistAi - Ai crm"} />
                  AI-powered CRM
                </span>

              </motion.h2>
            </div>
            <div className={classes.integrationRight}>
              <motion.p
                initial={{ opacity: 1, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                className="font-wix-regular font-18 font-white"
              >
                Use the power of generative AI to reduce manual work, improve follow-ups, and help your sales and support team stay consistent from first touch to deal closure and beyond.
              </motion.p>
              <div className="buttons">
                <div className="buttonContaienr">
                  <Link
                    className="transparentButton font-wix-medium font-14 font-white"
                    to={"/sales-crm-features/ai-crm-tool-for-small-business/"}
                  >
                    AI-powered CRM
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className={classes.bentoContainer}>
            <div className={classes.bentoRow1}>
              <div className={clsx(classes.bentoCard, 'card1', "purpleCard")}>
                <div className="content">
                  <p className="font-20 font-wix-bold font-white">AI Voice-to-notes</p>
                  <p className="font-16 font-wix-regular font-white">Transform voice into AI-powered structured notes and logs and associate them to leads and contacts.</p>
                </div>
              </div>
              <div className={clsx(classes.bentoCard, 'card2', "blueCard")}>
                <div className="content">
                  <p className="font-20 font-wix-bold font-white">AI Agents</p>
                  <p className="font-16 font-wix-regular font-white">Automate lead scoring, follow-ups, taking meeting notes, and more with intelligent AI agents.</p>

                </div>
              </div>
              <div className={clsx(classes.bentoCard, 'card3', "regularCard")}>
                <div className="content">
                  <p className="font-20 font-wix-bold font-white">AI Insights</p>
                  <p className="font-16 font-wix-regular font-white">Create chats and VoIP call insights automatically using the power of AI. Generate summaries, action items, tasks, and more.</p>
                </div>
              </div>
            </div>
            <div className={classes.bentoRow2}>
              <div className={clsx(classes.bentoCard, 'card4', "purpleCard")}>
                <div className="content">
                  <p className="font-20 font-wix-bold font-white">Workflow Automation</p>
                  <p className="font-16 font-wix-regular font-white">Automate sales and support with intelligent workflow automation. Auto-trigger actions, analyse sentiments, send follow-ups, and more.</p>
                </div>
              </div>
            </div>
            <div className={classes.bentoRow3}>
              <div className={clsx(classes.bentoCard, 'card5', "regularCard")}>
                <div className="content">
                  <p className="font-20 font-wix-bold font-white">AI Translation</p>
                  <p className="font-16 font-wix-regular font-white">Automatically translate messages and replies in real-time across all channels, ensuring seamless conversations.</p>

                </div>
              </div>
              <div className={clsx(classes.bentoCard, 'card6', "blueCard")}>
                <div className="content">
                  <p className="font-20 font-wix-bold font-white">AI Chatbot</p>
                  <p className="font-16 font-wix-regular font-white">Reply to customers instantly across WhatsApp, Facebook, and more, even when you are offline, using AI chatbot.</p>

                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className={classes.whatsappCRM}>
        <div className="container">
          <div className={classes.integrationHeader}>
            <div className={classes.integrationLeft}>
              <motion.h2
                initial={{ opacity: 1, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                className="font-wix-semibold font-56 color-black"
              >
                Turn conversations into opportunities with
                <br />
                <span className="whatsappCrmIcon font-wix-semibold font-56 color-black">
                  <img
                    src={whatsappIcon}
                    alt={"Whatsapp CRM"}
                    style={{ verticalAlign: "middle" }}
                  />
                  Whatsapp CRM
                </span>
              </motion.h2>
            </div>
            <div className={classes.integrationRight}>
              <motion.p
                initial={{ opacity: 1, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                className="font-wix-regular font-18 color-black"
              >
                Manage conversations, broadcast campaigns and customer
                interactions directly from one powerful WhatsApp CRM.
              </motion.p>
              <div className="buttons">
                <div className="buttonContaienr">
                  <Link
                    className="primaryButtonOutline font-wix-medium font-14 "
                    to={"/whatsapp-crm/"}
                  >
                    WhatsApp Sales
                  </Link>
                </div>
                <div className="buttonContaienr">
                  <Link
                    className="primaryButtonOutline font-wix-medium font-14  "
                    to={"/whatsapp-crm-for-customer-support"}
                  >
                    WhatsApp Support
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <ul id="cards">
            {capabilities.map((data, index) => (
              <li className="card" id={`card-${index + 1}`}>
                <div
                  className={clsx("card-content", classes.cardBackground)}
                  style={{
                    backgroundImage: `url(${data.background})`,
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                  }}
                >
                  <div className="cardContentData">
                    <h3 className="cardHeading font-wix-medium">
                      {data.heading}
                    </h3>
                    <p className="cardDesciption">{data.desc}</p>
                    <div className="cardList">
                      {data.points.map((point, j) => (
                        <div className="listItem">
                          <LazyImage source={checkIcon} alt={"pointerIcon"} />
                          <p>{point}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="cardImg">
                    <img
                      src={data.image}
                      alt={data.alt}
                      className={classes.broadcastImg}
                    />
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </section>
      <section className={classes.keyFeature}>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-56 font-black1"
            >
              <span className="gradientTitle">Sell and Support</span> <br />{" "}
              with AI WhatsApp CRM
            </motion.h2>
            <motion.p
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-regular font-20 font-black1"
            >
              Respond faster, close more deals, and resolve issues effortlessly
              with the combined power of WhatsApp, AI, and CRM. Turn every
              conversation into revenue with the powerful all-in-one CRM.
            </motion.p>
          </div>
          <div className={classes.keyFeatureContainer}>
            <div className={classes.keyBlock}>
              {featureList1.map((feature) => (
                <div className={classes.keyBox}>
                  <img src={feature.icon} alt="Smart customer support CRM" />
                  <p className="font-wix-semibold font-24 font-black2">
                    {feature.title}
                  </p>
                  <p className="font-wix-regular font-18 font-black4">
                    {feature.desc}
                  </p>
                </div>
              ))}
            </div>
            <img
              src={keyImg}
              className="keyImg"
              alt="ai powered whatsapp crm dashboard for sales and support"
            />
            <div className={classes.keyBlock}>
              {featureList2.map((feature) => (
                <div className={classes.keyBox}>
                  <img src={feature.icon} />
                  <p className="font-wix-semibold font-24 font-black2">
                    {feature.title}
                  </p>
                  <p className="font-wix-regular font-18 font-black4">
                    {feature.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      <section className={classes.combineSection}>
        <div className={classes.bussinessSuccesSection}>
          <div className={classes.bussinessSuccessContainer}>
            <div className={classes.integrationHeaderItem}>
              <div className={classes.integrationContent}>
                <motion.p
                  className="font-wix-semibold font-20 color-black7"
                  initial={{ opacity: 1, y: 20 }}
                  transition={{ duration: 0.3 }}
                  whileInView={{ opacity: 1, y: 0 }}
                >
                  Features
                </motion.p>
                <motion.h2
                  className="font-wix-semibold font-56 color-black7"
                  initial={{ opacity: 1, y: 20 }}
                  transition={{ duration: 0.3 }}
                  whileInView={{ opacity: 1, y: 0 }}
                >
                  Tailored for business success
                </motion.h2>
                <motion.p
                  className="font-wix-regular font-18"
                  initial={{ opacity: 1, y: 20 }}
                  transition={{ duration: 0.3 }}
                  whileInView={{ opacity: 1, y: 0 }}
                >
                  The best CRM for sales reps who want to streamline their sales
                  process, stay organised, and win more deals.
                </motion.p>
              </div>
            </div>

            <section className="sales-logo-carousel">
              <div className="logos-container">
                <div className="scroll-container">
                  <div
                    className="logos-row"
                    data-direction="left"
                    data-speed="0.8"
                  >
                    <div className="logos-track">
                      {logotrack1.map((logo) => (
                        <div
                          className="logo font-18 font-wix-medium"
                          key={logo.title}
                        >
                          <img
                            alt={`${logo.title} integration`}
                            src={logo.img}
                          />
                          <p>{logo.title}</p>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div
                    className="logos-row"
                    data-direction="right"
                    data-speed="0.4"
                  >
                    <div className="logos-track">
                      {logotrack2.map((logo) => (
                        <div className="logo font-18 font-wix-medium">
                          <img
                            alt={`${logo.title} integration`}
                            src={logo.img}
                          />
                          <p>{logo.title}</p>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div
                    className="logos-row"
                    data-direction="left"
                    data-speed="0.8"
                  >
                    <div className="logos-track">
                      {logotrack3.map((logo) => (
                        <div className="logo font-18 font-wix-medium">
                          <img
                            alt={`${logo.title} integration`}
                            src={logo.img}
                          />
                          <p>{logo.title}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div
                    className="logos-row"
                    data-direction="right"
                    data-speed="0.8"
                  >
                    <div className="logos-track">
                      {logotrack1.map((logo) => (
                        <div className="logo font-18 font-wix-medium">
                          <img
                            alt={`${logo.title} integration`}
                            src={logo.img}
                          />
                          <p>{logo.title}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
        <div className={classes.absoulteCard}>
          <TruestedSection shadow={true} background={true} />
        </div>
      </section>
      <section className={classes.pricingSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-56 font-black1"
            >
              Exclusive Business Mastercard member pricing
            </motion.h2>

          </div>
          <div className={classes.pricingContainer}>
            <div className={clsx(classes.pricingBox, "blueCard1")}>
              <div className="tag">
                <img src={starterIcon} alt="pepper cloud ai whatsapp crm platform" />
                <p className="font-18 font-wix-bold font-white">Starter</p>
              </div>
              <div className="cutActualContainer">
                <div className="cutPrice">
                  <p className="font-24 font-white font-wix-semibold slashPrice">$200</p>
                  <p className="font-12 font-wix-bold font-white offPrice">50% off</p>
                </div>
                <div className="actualPrice">
                  <p className="font-48 font-white font-wix-bold">$100</p>
                  <p className="font-14 font-white font-wix-regular">Per user/month</p>
                </div>
              </div>
              <p
                className=" transparentButton font-wix-medium font-14 font-white"
                onClick={() => scrollToTop()}
              >
                Try now
              </p>
              <div className={classes.pricingPointers}>
                <div className={classes.pricingPointer}>
                  <img src={whiteCheckIcon} alt="pointer" />
                  <p className="font-14 font-wix-regular font-white">1 User included</p>
                </div>
                <div className={classes.pricingPointer}>
                  <img src={whiteCheckIcon} alt="pointer" />
                  <p className="font-14 font-wix-regular font-white">3 Months FREE access</p>
                </div>

                <div className={classes.pricingPointer}>
                  <img src={whiteCheckIcon} alt="pointer" />
                  <p className="font-14 font-wix-regular font-white">3 Workflow setups</p>
                </div>
                <div className={classes.pricingPointer}>
                  <img src={whiteCheckIcon} alt="pointer" />
                  <p className="font-14 font-wix-regular font-white">1 Messaging channel</p>
                </div>
              </div>
            </div>
            <div className={clsx(classes.pricingBox, "purpleCard1")}>
              <div className="tag">
                <img src={advancedIcon} alt="ai powered whatsapp crm dashboard for sales and support" />
                <p className="font-18 font-wix-bold font-white">Advanced</p>
              </div>
              <div className="cutActualContainer">
                <div className="cutPrice">
                  <p className="font-24 font-white font-wix-semibold slashPrice">$160</p>
                  <p className="font-12 font-wix-bold font-white offPrice">50% off</p>
                </div>
                <div className="actualPrice">
                  <p className="font-48 font-white font-wix-bold">$80</p>
                  <p className="font-14 font-white font-wix-regular">Per user/month</p>
                </div>
              </div>
              <p
                className=" transparentButton font-wix-medium font-14 font-white"
                onClick={() => scrollToTop()}
              >
                Try now
              </p>
              <div className={classes.pricingPointers}>
                <div className={classes.pricingPointer}>
                  <img src={whiteCheckIcon} alt="pointer" />
                  <p className="font-14 font-wix-regular font-white">5 Users included</p>
                </div>
                <div className={classes.pricingPointer}>
                  <img src={whiteCheckIcon} alt="pointer" />
                  <p className="font-14 font-wix-regular font-white">9 Months FREE access</p>
                </div>
                <div className={classes.pricingPointer}>
                  <img src={whiteCheckIcon} alt="pointer" />
                  <p className="font-14 font-wix-regular font-white">10 Workflow setups</p>
                </div>
                <div className={classes.pricingPointer}>
                  <img src={whiteCheckIcon} alt="pointer" />
                  <p className="font-14 font-wix-regular font-white">All messaging channels</p>
                </div>
              </div>
            </div>
            <div className={clsx(classes.pricingBox, "regularCard1")}>

              <div className="tag">
                <img src={basicIcon} alt="ai whatsapp crm for sales and support" />
                <p className="font-18 font-wix-bold font-white">Basic</p>
              </div>
              <div className="cutActualContainer">
                <div className="cutPrice">
                  <p className="font-24 font-white font-wix-semibold slashPrice">$180</p>
                  <p className="font-12 font-wix-bold font-white offPrice">50% off</p>
                </div>
                <div className="actualPrice">
                  <p className="font-48 font-white font-wix-bold">$90</p>
                  <p className="font-14 font-white font-wix-regular">Per user/month</p>
                </div>
              </div>
              <p
                className=" transparentButton font-wix-medium font-14 font-white"
                onClick={() => scrollToTop()}
              >
                Try now
              </p>
              <div className={classes.pricingPointers}>
                <div className={classes.pricingPointer}>
                  <img src={whiteCheckIcon} alt="pointer" />
                  <p className="font-14 font-wix-regular font-white">3 User included</p>
                </div>
                <div className={classes.pricingPointer}>
                  <img src={whiteCheckIcon} alt="pointer" />
                  <p className="font-14 font-wix-regular font-white">6 Months FREE access</p>
                </div>
                <div className={classes.pricingPointer}>
                  <img src={whiteCheckIcon} alt="pointer" />
                  <p className="font-14 font-wix-regular font-white">5 Workflow setups</p>
                </div>
                <div className={classes.pricingPointer}>
                  <img src={whiteCheckIcon} alt="pointer" />
                  <p className="font-14 font-wix-regular font-white">2 Messaging channels</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className={classes.wpFaq}>
        <FaqSection
          backgroundColor={"#FFFFFF"}
          heading={"AI WhatsApp CRM - Frequently asked questions"}
          faqs={faqs}
        />
      </div>
      <section className={classes.commonPageFooterSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              className="font-wix-medium font-56 font-white"
              initial={{ opacity: 1, y: 30 }}
              transition={{ duration: 0.5 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              AI WhatsApp CRM for Sales and Support
            </motion.h2>
            <p
              className="primaryButton font-20 font-wix-medium font-white"
              onClick={() => scrollToTop()}
            >
              Book a free demo
            </p>
          </div>
        </div>
      </section>
    </main>
  );
};

export default MasterCard;
